import React from 'react';

// CSS filter to colorize the logo to #90472d
// This creates a sepia-like effect that matches the brand color
const brandColorFilter = {
  filter: 'brightness(0) saturate(100%) invert(25%) sepia(50%) saturate(800%) hue-rotate(345deg) brightness(95%) contrast(95%)'
};

/**
 * Lithae Logo component - uses the official logo images
 * @param {string} variant - "brown" (default) or "white"
 * @param {string} type - "full" (with text) or "icon" (symbol only)
 * @param {string} size - "small", "default", or "large"
 * @param {boolean} useBrandColor - apply #90472d color filter
 */
export const LithaeLogo = ({ 
  className = "", 
  size = "default", 
  variant = "brown",
  type = "full",
  useBrandColor = true
}) => {
  const sizes = {
    small: { height: 28 },
    default: { height: 36 },
    large: { height: 48 }
  };
  
  const { height } = sizes[size] || sizes.default;
  
  // Select the correct logo based on variant and type
  const logoSrc = type === "icon" 
    ? (variant === "white" ? "/lithae-icon-white.png" : "/lithae-icon-brown.png")
    : (variant === "white" ? "/lithae-logo-white-full.png" : "/lithae-logo-brown-full.png");
  
  return (
    <img 
      src={logoSrc}
      alt="Lithae" 
      height={height}
      style={{ 
        height: `${height}px`, 
        width: 'auto',
        ...(useBrandColor && variant === "brown" ? brandColorFilter : {})
      }}
      className={`object-contain ${className}`}
    />
  );
};

/**
 * Lithae Icon component - just the heart/gem circle symbol
 * @param {string} variant - "brown" (default) or "white"
 * @param {number} size - size in pixels
 * @param {boolean} useBrandColor - apply #90472d color filter
 */
export const LithaeIcon = ({ className = "", size = 24, variant = "brown", useBrandColor = true }) => {
  const logoSrc = variant === "white" ? "/lithae-icon-white.png" : "/lithae-icon-brown.png";
  
  return (
    <img 
      src={logoSrc}
      alt="Lithae" 
      width={size}
      height={size}
      style={{ 
        width: `${size}px`, 
        height: `${size}px`,
        ...(useBrandColor && variant === "brown" ? brandColorFilter : {})
      }}
      className={`object-contain ${className}`}
    />
  );
};

export default LithaeLogo;
